export default __webpack_public_path__ + "static/PersonalLoanGirl-99e9c29cfefa16e1cc41f2faf6ec80fa.jpg";